import service from "./service";
import endpoint from "./constantUrl";

// Dashboard Blockchain
export const getSummary = () => {
  return service.get(`${endpoint.MARLIN_URL}/v1/trades/summary`);
};
